module.exports = __webpack_public_path__ + "78a7e6d33921681c8f89ab561ec0d980.png";